export default "__VITE_ASSET__CjDHwwPH__"